import React, { useState } from 'react';
import { Button } from 'primereact/button';
import useGlobalState, { g_user } from '../globalState';
import './AppInstallBanner.css';

const DISMISS_KEY = 'mozo-app-banner-dismissed';
const IOS_STORE = 'https://apps.apple.com/us/app/mozo-mobile/id6477692711';
const ANDROID_STORE = 'https://play.google.com/store/apps/details?id=com.mozo.mozomobile';

const getMobilePlatform = () => {
   if (typeof navigator === 'undefined') {
      return null;
   }

   const ua = navigator.userAgent || '';
   const isIOS = /iPhone|iPad|iPod/i.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
   const isAndroid = /Android/i.test(ua);

   if (isIOS) {
      return 'ios';
   }
   if (isAndroid) {
      return 'android';
   }
   return null;
};

const isStandaloneOrWebView = () => {
   if (typeof window === 'undefined') {
      return false;
   }
   if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      return true;
   }
   if (window.navigator.standalone) {
      return true;
   }
   return /; wv\)/i.test(navigator.userAgent || '');
};

export const AppInstallBanner = () => {
   const [user] = useGlobalState(g_user);
   const [dismissed, setDismissed] = useState(() => {
      try {
         return window.localStorage.getItem(DISMISS_KEY) === '1';
      } catch (e) {
         return false;
      }
   });

   const isAuthenticated = user !== undefined && user !== null;
   const platform = getMobilePlatform();

   if (!isAuthenticated || !platform || dismissed || isStandaloneOrWebView()) {
      return null;
   }

   const storeUrl = platform === 'ios' ? IOS_STORE : ANDROID_STORE;
   const storeName = platform === 'ios' ? 'the App Store' : 'Google Play';

   const dismiss = () => {
      try {
         window.localStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {
         // ignore storage failures (private mode)
      }
      setDismissed(true);
   };

   return (
      <div className="app-install-banner" role="region" aria-label="Get the Mozo Mobile app">
         <div className="app-install-banner-copy">
            <div className="app-install-banner-title">Get Mozo Mobile</div>
            <div className="app-install-banner-text">
               The app works better on this device. Open {storeName} to install it.
            </div>
         </div>
         <div className="app-install-banner-actions">
            <Button
               label="Install"
               icon="pi pi-download"
               className="app-install-banner-cta"
               onClick={() => { window.location.href = storeUrl; }}
            />
            <Button
               icon="pi pi-times"
               rounded
               text
               aria-label="Dismiss"
               className="app-install-banner-dismiss"
               onClick={dismiss}
            />
         </div>
      </div>
   );
};
